<template>
  <v-data-table
    v-if="hasAccess"
    :headers="headers"
    :items="data"
    :search="search"
    class="elevation-1"
  >
    <template v-slot:top>
      <v-container fluid>
        <v-row>
          <v-col
            cols="12"
            sm="4"
            md="4"
            class="table__top-header"
          >
            <v-toolbar-title>{{ $vuetify.lang.t('$vuetify.groups') }}</v-toolbar-title>
            <v-divider
              class="mx-4"
              inset
              vertical
            />
          </v-col>
          <v-col
            cols="12"
            sm="8"
            md="8"
            class="table__top-tools"
          >
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              :label="$vuetify.lang.t('$vuetify.search')"
              single-line
              hide-details
              style="max-width: 250px;"
            />
            <v-dialog
              v-model="deleteDialog"
              persistent
            >
              <v-card>
                <v-card-title class="headline">
                  {{ $vuetify.lang.t('$vuetify.generalDeleteMessage') }}
                </v-card-title>
                <v-card-actions>
                  <v-spacer />
                  <v-btn
                    color="primary"
                    text
                    @click="deleteDialog = false"
                  >
                    {{ $vuetify.lang.t('$vuetify.cancel') }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    text
                    @click="deleteAction"
                  >
                    {{ $vuetify.lang.t('$vuetify.delete') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="dialog"
              persistent
            >
              <template v-slot:activator="{ on }">
                <v-btn
                  color="primary"
                  dark
                  v-on="on"
                >
                  {{ $vuetify.lang.t('$vuetify.newItem') }}
                </v-btn>
              </template>
              <v-card>
                <v-card-title>
                  <span class="headline">{{ formTitle }}</span>
                </v-card-title>

                <v-card-text>
                  <v-container>
                    <v-row>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <v-text-field
                          v-model="editedItem.name"
                          :label="$vuetify.lang.t('$vuetify.name')"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <v-select
                          v-model="editedItem.permissions"
                          :items="permissionDataSelect"
                          attach
                          chips
                          multiple
                          :label="$vuetify.lang.t('$vuetify.permissions')"
                        />
                      </v-col>
                      <v-col
                        cols="12"
                        sm="12"
                        md="12"
                      >
                        <v-select
                          v-model="editedItem.microcontrollers"
                          :items="microcontrollerDataSelect"
                          attach
                          chips
                          multiple
                          :label="$vuetify.lang.t('$vuetify.machine')"
                        />
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>

                <v-card-actions>
                  <div class="flex-grow-1" />
                  <v-btn
                    color="secondary"
                    text
                    @click="close"
                  >
                    {{ $vuetify.lang.t('$vuetify.cancel') }}
                  </v-btn>
                  <v-btn
                    color="secondary"
                    text
                    @click="save"
                  >
                    {{ $vuetify.lang.t('$vuetify.save') }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </v-container>
    </template>
    <template v-slot:item.action="{ item }">
      <v-icon
        small
        class="mr-2"
        @click="editItem(item)"
      >
        mdi-pencil
      </v-icon>
      <v-icon
        small
        @click="deleteItem(item)"
      >
        mdi-delete
      </v-icon>
    </template>
    <template v-slot:no-data>
      <v-btn
        color="primary"
        @click="initialize"
      >
        {{ $vuetify.lang.t('$vuetify.reset') }}
      </v-btn>
    </template>
  </v-data-table>
</template>

<script>
import lodash from 'lodash';
import apiUtil from '../utils/ApiUtil';

export default {
  data: () => {
    return {
      permissionsKey: 1,
      search: '',
      dialog: false,
      deleteDialog: false,
      deletedItem: {},
      data: [],
      permissionData: [],
      microcontrollerData: [],
      editedIndex: -1,
      editedItem: {
        name: '',
        microcontrollers: [],
        permissions: [],
      },
      defaultItem: {
        name: '',
        microcontrollers: [],
        permissions: [],
      },
    };
  },
  computed: {
    hasAccess() {
      return this.$store.state.user.permissions.indexOf(this.permissionsKey) >= 0;
    },
    formTitle() {
      return this.editedIndex === -1 ? this.$vuetify.lang.t('$vuetify.newItem') : this.$vuetify.lang.t('$vuetify.editItem');
    },
    permissionDataSelect() {
      if (!this.permissionData.length) {
        return [];
      }
      const result = [];
      for (const item of this.permissionData) {
        result.push({ text: item.name, value: item.id });
      }
      return result;
    },
    microcontrollerDataSelect() {
      if (!this.microcontrollerData.length) {
        return [];
      }
      const result = [];
      for (const item of this.microcontrollerData) {
        result.push({ text: item.machineDisplayName, value: item.id });
      }
      return result;
    },
    headers() {
      return [
        { text: 'ID', value: 'id' },
        { text: this.$vuetify.lang.t('$vuetify.name'), value: 'name' },
        { text: this.$vuetify.lang.t('$vuetify.actions'), value: 'action', sortable: false },
      ];
    },
  },
  watch: {
    dialog(val) {
      if (!val) {
        this.close();
      }
    },
  },
  async created() {
    this.$store.dispatch('setGlobalLoading', true);
    await this.initialize();
    this.$store.dispatch('setGlobalLoading', false);
  },
  methods: {
    async initialize() {
      const result = await apiUtil.getAllGroup();
      this.data = result;
      const permissionResult = await apiUtil.getAllPermission();
      this.permissionData = permissionResult;
      const microcontrollerResult = await apiUtil.getAllMicrocontroller();
      this.microcontrollerData = microcontrollerResult;
    },
    editItem(item) {
      const itemCloned = lodash.cloneDeep(item);
      const newPermission = [];
      const newMicrocontroller = [];
      for (const permissionItem of itemCloned.permissions) {
        newPermission.push(permissionItem.permission_id);
      }
      for (const microcontrollerItem of itemCloned.microcontrollers) {
        newMicrocontroller.push(microcontrollerItem.microcontroller_id);
      }
      itemCloned.permissions = newPermission;
      itemCloned.microcontrollers = newMicrocontroller;
      this.editedItem = itemCloned;
      this.editedIndex = this.data.findIndex((i) => { return i.id === this.editedItem.id; });
      this.dialog = true;
    },
    deleteItem(item) {
      this.deletedItem = item;
      this.deleteDialog = true;
    },
    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async deleteAction() {
      const index = this.data.findIndex((i) => { return i.id === this.deletedItem.id; });
      const result = await apiUtil.deleteGroupById(this.deletedItem);
      if (result) {
        this.data.splice(index, 1);
      }
      this.deleteDialog = false;
    },
    async save() {
      const response = await apiUtil.saveGroup(this.editedItem);
      const preparedData = {
        client_id: response.group.client_id, id: response.group.id, name: response.group.name, permissions: response.permissions, microcontrollers: response.microcontrollers,
      };
      if (this.editedIndex > -1) {
        Object.assign(this.data[this.editedIndex], preparedData);
      } else {
        this.data.push(preparedData);
      }

      this.close();
    },
  },
};
</script>
